export const TRADE_REQUEST_FILTERS_KEY = 'trade_request_filters';

export const TRADE_REQUEST_STATUS_NOT_STARTED = 'Not Started';
export const TRADE_REQUEST_STATUS_IN_PROGRESS = 'In Progress';
export const TRADE_REQUEST_STATUS_BLOCKED = 'Blocked';
export const TRADE_REQUEST_STATUS_COMPLETED = 'Completed';
export const TRADE_REQUEST_STATUSES = [
  TRADE_REQUEST_STATUS_NOT_STARTED,
  TRADE_REQUEST_STATUS_IN_PROGRESS,
  TRADE_REQUEST_STATUS_BLOCKED,
  TRADE_REQUEST_STATUS_COMPLETED,
] as const;
export type TradeRequestStatus = typeof TRADE_REQUEST_STATUSES[number];

export const TRADE_REQUEST_TAGS = [
  'Debit Resolution',
  'Raise Cash',
  'Risk Profile Changes',
  'Deploy Cash',
  'Model Construction',
  'PAC/SWP Investment Direction Change',
  'Model Rebalance',
  'Tax-Driven Trades',
  'Other',
] as const;
export type TradeRequestTag = typeof TRADE_REQUEST_TAGS[number];

export interface TradeRequestItem {
  taskId: number;
  taskUuid: string;
  title: string;
  householdQID: string;
  householdName: string;
  partnerId: number;
  partnerName: string;
  iaCode: string;
  dueDate: string | null;
  status: TradeRequestStatus | null;
  assignedTo: string | null;
  assignedToUuid: string | null;
  assigneeEmail: string | null;
  details: string | null;
  tags: string[];
  createdAt: string | null;
}

export interface TradeRequestsResponse {
  items: TradeRequestItem[];
  total: number;
  page: number;
  pageSize: number;
}

export interface TradeRequestFilters {
  status: TradeRequestStatus | null;
  partnerName: string | null;
  assignedTo: string | null;
  tag: string | null;
  dueDateStart: string | undefined;
  dueDateEnd: string | undefined;
}

export interface TradeRequestQueryParams {
  page?: number;
  pageSize?: number;
  status?: string;
  assignedTo?: string;
  tags?: string;
  dueDateFrom?: string;
  dueDateTo?: string;
  search?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}
